import React from 'react'
import { Translate } from '../../../language';
import ImageNameDescription from '../../../utils/components/ImageNameDescription/ImageNameDescription';
import style from './ZoneRoomAdmin.module.css'
const AdminZoneRequest = ({ requests, accept, reject }) => {
    return (
        <div className={style.content_right_container}>
            <div className={style.list_item}>
                {requests.map((member) => {
                     let src = null
                     let id = null;
                     let name = null
                     let lastname = null
                     if (member.memberType ==="user") {
                         id = member.userId._id
                         name = member.userId.name
                         lastname = member.userId.lastname
                         src = member.userId.picture && member.userId.picture.url && member.userId.picture.url.small
                     }
                     if (member.memberType ==="franchise") {
                         id = member.franchiseId._id
                         name = member.franchiseId.socialReason
                         src = member.franchiseId.picture && member.franchiseId.picture.url && member.franchiseId.picture.url.small
                     }
                     if (member.memberType ==="representative") {
                         id = member.representativeId._id
                         name = member.representativeId.userID.name
                         lastname = member.representativeId.userID.lastname
                         src = member.representativeId.userID.picture &&
                             member.representativeId.userID.picture.url &&
                             member.representativeId.userID.picture.url.small
                     }
                     if (member.memberType ==="warehouse") {
                         id = member.warehouseId._id
                         name = member.warehouseId.name
                         src = member.warehouseId.profileId.picture &&
                             member.warehouseId.profileId.picture.url &&
                             member.warehouseId.profileId.picture.url.small
                     }
                    return (
                        <div key={member._id}>
                            <ImageNameDescription
                                type={"header-message"}
                                srcImage={src}
                                firstName={name}
                                secondName={lastname}
                                typeOneText="purple"
                                options={[

                                    {
                                        text: Translate('accept', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            accept(member._id)
                                        }
                                    },
                                    {
                                        text: Translate('reject', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();
                                            reject(member._id)
                                        }
                                    },
                                ]}

                            />

                        </div>
                    )
                }
                )}
            </div>
        </div>
    )
}

export default AdminZoneRequest